import ProductPage from "../pages/Product";
import ProductCategoryPage from "../pages/ProductCategory";
import ProductDetailsPage from "../pages/ProductDetails";
import SearchPage from "../pages/Search";

const routesProduct = [
  {
    path: "/products",
    element: <ProductPage />,
  },
  {
    path: "/productdetails/:code",
    element: <ProductDetailsPage />,
  },
  {
    path: "/productcategory/:category",
    element: <ProductCategoryPage />,
  },
  {
    path: "/productbysearch/:searchkey", //TODO::search
    element: <SearchPage />,
  },
];

export default routesProduct;
